import { NgModule } from "@angular/core";
import { LoginIndexComponent } from "./pages/index/index.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { LoginRoutingModule } from "./login.routing";
import { SharedModule } from "src/app/shared/shared.module";
import { DialogModalComponent } from "src/app/shared/components/dialog-modal/dialog-modal.component";
import { NgxLoadingModule } from 'ngx-loading';
import { QrLoginComponent } from './qr-login/qr-login.component';
import { QRCodeModule } from "angularx-qrcode";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    NgxLoadingModule,
    QRCodeModule,
  ],
  exports: [],
  declarations: [LoginIndexComponent, QrLoginComponent],
  providers: [
   
  ],
  entryComponents: [DialogModalComponent],
})
export class LoginModule {}
